import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  MenuItem,
  Select,
  FormControl,
  IconButton,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import EventIcon from "@mui/icons-material/Event";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { collection, getDocs, addDoc, getDoc, doc } from "firebase/firestore";
import { firestore } from "firebaseConfig";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { auth } from "firebaseConfig";
import { query, where } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Importar Firebase Storage
import { storage } from "firebaseConfig"; // Certifique-se de configurar o storage
import { useMaterialUIController } from "context";
import logoBranca from "assets/images/logos/LogoSemFundo.png";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function PainelConsultor() {
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [modalRelatorioOpen, setModalRelatorioOpen] = useState(false);
  const [modalReuniaoOpen, setModalReuniaoOpen] = useState(false);
  const [modalRecomendacaoOpen, setModalRecomendacaoOpen] = useState(false);
  const [modalVisualizarOpen, setModalVisualizarOpen] = useState(false);
  const [relatorioFile, setRelatorioFile] = useState(null);
  const [recomendacaoTexto, setRecomendacaoTexto] = useState("");
  const [reuniaoData, setReuniaoData] = useState("");
  const [reuniaoHora, setReuniaoHora] = useState("");
  const [historicoReunioes, setHistoricoReunioes] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller; // Obtém o estado do modo escuro
  const [receitas, setReceitas] = useState([]);
  const [despesasFixas, setDespesasFixas] = useState([]);
  const [despesasVariaveis, setDespesasVariaveis] = useState([]);
  const [saldo, setSaldo] = useState(0);

  const [userDetails, setUserDetails] = useState({
    lancamentos: [],
    metas: [],
    investimentos: [],
  });

  const getUserRole = async (userId) => {
    try {
      const userDoc = await getDoc(doc(firestore, "usuarios", userId));
      return userDoc.exists() ? userDoc.data().role : null;
    } catch (error) {
      console.error("Erro ao buscar role do usuário:", error.message || error);
      return null;
    }
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Adiciona o nome do cliente no topo
    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40); // Cor do texto
    doc.text("Relatório de Cliente", 10, 10);
    if (selectedCliente?.name) {
      doc.setFontSize(14);
      doc.text(`Cliente: ${selectedCliente.name}`, 10, 20);
    }

    let currentY = 30; // Posição Y inicial

    // Estilos de cores
    const tableColors = {
      lancamentos: [0, 86, 100], // Azul petróleo
      metas: [128, 0, 128], // Roxo
      investimentos: [138, 43, 226], // Violeta
      rowAlternate: [240, 240, 240], // Fundo claro para linhas alternadas
    };

    // Adiciona Tabela de Lançamentos
    doc.setFontSize(16);
    doc.setTextColor(...tableColors.lancamentos); // Roxo para o título
    doc.text("Lançamentos", 10, currentY);
    currentY += 10;
    autoTable(doc, {
      startY: currentY,
      head: [["Data", "Categoria", "Forma de Pagamento", "Valor", "Status"]],
      body: userDetails.lancamentos.map((lancamento) => [
        lancamento.data ? new Date(lancamento.data).toLocaleDateString("pt-BR") : "Não informado",
        lancamento.categoria || "Não informado",
        lancamento.formaPagamento || "Não informado",
        `R$ ${
          lancamento.valor?.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }) || "0,00"
        }`,
        lancamento.pago ? "Pago" : "Não Pago",
      ]),
      theme: "grid",
      headStyles: { fillColor: tableColors.lancamentos, textColor: 255 },
      bodyStyles: { fillColor: [255, 255, 255], textColor: 0 },
      alternateRowStyles: { fillColor: tableColors.rowAlternate },
    });

    currentY = doc.lastAutoTable.finalY + 10;

    // Adiciona Tabela de Metas
    doc.setFontSize(16);
    doc.setTextColor(...tableColors.metas); // Azul para o título
    doc.text("Metas", 10, currentY);
    currentY += 10;
    autoTable(doc, {
      startY: currentY,
      head: [["Meta", "Valor", "Total Aportado", "Prazo", "Dias Restantes"]],
      body: userDetails.metas.map((meta) => [
        meta.nome || "Não informado",
        `R$ ${meta.valor?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}`,
        `R$ ${
          meta.aportesRegistrados
            ? meta.aportesRegistrados
                .reduce((total, aporte) => total + aporte, 0)
                .toLocaleString("pt-BR", { minimumFractionDigits: 2 })
            : "0,00"
        }`,
        meta.prazo ? new Date(meta.prazo).toLocaleDateString("pt-BR") : "Não informado",
        meta.prazo
          ? Math.max(Math.ceil((new Date(meta.prazo).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)), 0) +
            " dias"
          : "Não informado",
      ]),
      theme: "grid",
      headStyles: { fillColor: tableColors.metas, textColor: 255 },
      bodyStyles: { fillColor: [255, 255, 255], textColor: 0 },
      alternateRowStyles: { fillColor: tableColors.rowAlternate },
    });

    currentY = doc.lastAutoTable.finalY + 10;

    // Adiciona Tabela de Investimentos
    doc.setFontSize(16);
    doc.setTextColor(...tableColors.investimentos); // Azul mais escuro para o título
    doc.text("Investimentos", 10, currentY);
    currentY += 10;
    autoTable(doc, {
      startY: currentY,
      head: [["Categoria", "Ativo", "Corretora", "Data", "Quantidade", "Valor Aplicado", "Indexador", "Taxa"]],
      body: userDetails.investimentos.map((investimento) => [
        investimento.categoria || "Não informado",
        investimento.ativo || "Não informado",
        investimento.corretora || "Não informado",
        investimento.data ? new Date(investimento.data).toLocaleDateString("pt-BR") : "Não informado",
        investimento.quantidade || "0",
        `R$ ${
          investimento.valorAplicado?.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }) || "0,00"
        }`,
        investimento.indexador || "Não informado",
        `${investimento.taxa || "0"}%`,
      ]),
      theme: "grid",
      headStyles: { fillColor: tableColors.investimentos, textColor: 255 },
      bodyStyles: { fillColor: [255, 255, 255], textColor: 0 },
      alternateRowStyles: { fillColor: tableColors.rowAlternate },
    });

    // Salvar PDF
    doc.save(`${selectedCliente?.name || "Relatório"}.pdf`);
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // Lançamentos
    const lancamentosData = [
      ["Data", "Categoria", "Forma de Pagamento", "Valor", "Status"], // Cabeçalho
      ...userDetails.lancamentos.map((lancamento) => [
        lancamento.data ? new Date(lancamento.data).toLocaleDateString("pt-BR") : "Não informado",
        lancamento.categoria || "Não informado",
        lancamento.formaPagamento || "Não informado",
        `R$ ${
          lancamento.valor?.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }) || "0,00"
        }`,
        lancamento.pago ? "Pago" : "Não Pago",
      ]),
    ];
    const lancamentosSheet = XLSX.utils.aoa_to_sheet(lancamentosData);
    XLSX.utils.book_append_sheet(wb, lancamentosSheet, "Lançamentos");

    // Metas
    const metasData = [
      ["Meta", "Valor", "Total Aportado", "Prazo", "Dias Restantes"], // Cabeçalho
      ...userDetails.metas.map((meta) => [
        meta.nome || "Não informado",
        `R$ ${meta.valor?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}`,
        `R$ ${
          meta.aportesRegistrados
            ? meta.aportesRegistrados
                .reduce((total, aporte) => total + aporte, 0)
                .toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                })
            : "0,00"
        }`,
        meta.prazo ? new Date(meta.prazo).toLocaleDateString("pt-BR") : "Não informado",
        meta.prazo
          ? Math.max(Math.ceil((new Date(meta.prazo).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)), 0) +
            " dias"
          : "Não informado",
      ]),
    ];
    const metasSheet = XLSX.utils.aoa_to_sheet(metasData);
    XLSX.utils.book_append_sheet(wb, metasSheet, "Metas");

    // Investimentos
    const investimentosData = [
      ["Categoria", "Ativo", "Corretora", "Data", "Quantidade", "Valor Aplicado", "Indexador", "Taxa"], // Cabeçalho
      ...userDetails.investimentos.map((investimento) => [
        investimento.categoria || "Não informado",
        investimento.ativo || "Não informado",
        investimento.corretora || "Não informado",
        investimento.data ? new Date(investimento.data).toLocaleDateString("pt-BR") : "Não informado",
        investimento.quantidade || "0",
        `R$ ${
          investimento.valorAplicado?.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }) || "0,00"
        }`,
        investimento.indexador || "Não informado",
        `${investimento.taxa || "0"}%`,
      ]),
    ];
    const investimentosSheet = XLSX.utils.aoa_to_sheet(investimentosData);
    XLSX.utils.book_append_sheet(wb, investimentosSheet, "Investimentos");

    // Salva o arquivo Excel
    XLSX.writeFile(wb, `${selectedCliente?.name || "Relatório"}.xlsx`);
  };

  useEffect(() => {
    fetchClientes();
  }, []);

  // Novo bloco de useEffect para buscar reuniões quando o modal for aberto
  useEffect(() => {
    const fetchHistoricoReunioes = async () => {
      if (selectedCliente) {
        try {
          const q = query(
            collection(firestore, `usuarios/${selectedCliente.id}/consultor`),
            where("tipo", "==", "reuniao")
          );

          const snapshot = await getDocs(q);
          const reunioes = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setHistoricoReunioes(reunioes);
        } catch (error) {
          console.error("Erro ao buscar histórico de reuniões:", error.message || error);
        }
      }
    };

    if (modalReuniaoOpen) {
      fetchHistoricoReunioes();
    }
  }, [modalReuniaoOpen, selectedCliente]);

  const fetchClientes = async () => {
    try {
      const user = auth.currentUser;

      if (!user) {
        console.error("Usuário não autenticado.");
        return;
      }

      // Busca o documento do usuário logado no Firestore
      const userDoc = await getDoc(doc(firestore, "usuarios", user.uid));

      if (!userDoc.exists()) {
        console.error("Documento do usuário não encontrado.");
        return;
      }

      const { role, linkedClients } = userDoc.data();
      let q;

      if (role === "admin") {
        // Admin: acessa todos os clientes
        q = query(
          collection(firestore, "usuarios"),
          where("role", "==", "cliente") // Apenas clientes
        );
      } else if (role === "consultor") {
        // Consultor: acessa apenas os clientes vinculados
        if (!linkedClients || linkedClients.length === 0) {
          console.warn("Nenhum cliente vinculado.");
          setClientes([]);
          return;
        }

        // Consulta apenas os clientes vinculados
        q = query(collection(firestore, "usuarios"), where("__name__", "in", linkedClients));
      } else {
        console.error("Usuário sem permissão para acessar este painel.");
        return;
      }

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        console.warn("Nenhum cliente encontrado.");
        setClientes([]);
        return;
      }

      const clientList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setClientes(clientList);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error.message || error);
    }
  };

  const fetchUserDetails = async (userId) => {
    try {
      const user = auth.currentUser;

      if (!user) {
        console.error("Usuário não autenticado.");
        return;
      }

      const userDoc = await getDoc(doc(firestore, "usuarios", user.uid));

      if (!userDoc.exists()) {
        console.error("Documento do usuário não encontrado.");
        return;
      }

      const { role, linkedClients } = userDoc.data();

      // Validar acesso do consultor
      if (role === "consultor" && (!linkedClients || !linkedClients.includes(userId))) {
        console.error("Cliente não está vinculado a este consultor.");
        return;
      }

      const lancamentosSnap = await getDocs(collection(firestore, "usuarios", userId, "lancamentos"));
      const metasSnap = await getDocs(collection(firestore, "usuarios", userId, "metas"));
      const investimentosSnap = await getDocs(collection(firestore, "usuarios", userId, "investimentos"));

      const lancamentos = lancamentosSnap.docs.map((doc) => doc.data());
      const metas = metasSnap.docs.map((doc) => doc.data());
      const investimentos = investimentosSnap.docs.map((doc) => doc.data());

      setUserDetails({ lancamentos, metas, investimentos });
      await fetchReunioes(userId);
      await fetchRelatorios(userId);
    } catch (error) {
      console.error("Erro ao buscar detalhes do cliente:", error.message || error);
    }
  };

  const fetchReunioes = async (clienteId) => {
    try {
      const q = query(collection(firestore, `usuarios/${clienteId}/consultor`), where("tipo", "==", "reuniao"));

      const snapshot = await getDocs(q);
      const reunioes = snapshot.docs.map((doc) => doc.data());
      setUserDetails((prevDetails) => ({ ...prevDetails, reunioes }));
    } catch (error) {
      console.error("Erro ao buscar reuniões:", error.message || error);
    }
  };

  const fetchRelatorios = async (userId) => {
    try {
      const relatoriosSnap = await getDocs(
        query(collection(firestore, `usuarios/${userId}/consultor`), where("tipo", "==", "relatorio"))
      );
      const relatorios = relatoriosSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUserDetails((prev) => ({ ...prev, relatorios }));
    } catch (error) {
      console.error("Erro ao buscar relatórios:", error.message || error);
    }
  };

  const handleViewUser = async (user) => {
    setSelectedCliente(user);
    await fetchUserDetails(user.id);
    setModalVisualizarOpen(true);
  };

  // Adiciona registro no Firebase para ações
  const saveConsultoriaData = async (tipo, conteudo) => {
    try {
      const user = auth.currentUser;

      if (!user) {
        console.error("Erro: Usuário não autenticado.");
        throw new Error("Usuário não autenticado.");
      }

      const userDoc = await getDoc(doc(firestore, "usuarios", user.uid));
      if (!userDoc.exists()) {
        console.error("Erro: Documento do usuário não encontrado.");
        throw new Error("Documento do usuário não encontrado.");
      }

      const { role, linkedClients } = userDoc.data();

      if (role === "admin" && !selectedCliente) {
        alert("Admin precisa selecionar um cliente antes de continuar.");
        return;
      }

      if (role === "consultor") {
        if (!selectedCliente) {
          console.error("Erro: Nenhum cliente selecionado.");
          alert("Nenhum cliente selecionado.");
          return;
        }

        if (!linkedClients || !linkedClients.includes(selectedCliente.id)) {
          console.error(`Cliente ${selectedCliente.id} não está vinculado ao consultor.`);
          alert("Consultor só pode enviar dados para clientes vinculados.");
          return;
        }
      }

      console.log("Salvando dados:", {
        tipo,
        conteudo,
        cliente: selectedCliente,
      });

      await addDoc(collection(firestore, `usuarios/${selectedCliente.id}/consultor`), {
        consultorId: user.uid,
        tipo,
        conteudo,
        data: new Date().toISOString(),
        status: "pendente",
      });

      console.log(`${tipo} salvo com sucesso!`);
    } catch (error) {
      console.error(`Erro ao salvar ${tipo}:`, error.message || error);
      throw error;
    }
  };

  // Substituir os métodos
  const handleRelatorioSubmit = async () => {
    if (!selectedCliente) {
      alert("Selecione um cliente antes de enviar o relatório.");
      return;
    }

    if (!relatorioFile) {
      alert("Carregue um arquivo PDF antes de enviar.");
      return;
    }

    try {
      // Upload do arquivo PDF para o Firebase Storage
      const storageRef = ref(storage, `relatorios/${selectedCliente.id}/${relatorioFile.name}`);
      const snapshot = await uploadBytes(storageRef, relatorioFile);
      console.log("Arquivo PDF enviado para o Storage:", snapshot);

      // Obter o URL do arquivo após o upload
      const fileLink = await getDownloadURL(snapshot.ref);
      console.log("URL do arquivo PDF:", fileLink);

      // Salvar o link no Firestore
      const conteudo = {
        consultorId: auth.currentUser?.uid, // ID do consultor que enviou o relatório
        tipo: "relatorio",
        conteudo: fileLink, // Link do arquivo PDF
        data: new Date().toISOString(),
        status: "enviado",
      };

      // Adicionar o link do relatório na coleção do cliente
      await addDoc(collection(firestore, `usuarios/${selectedCliente.id}/consultor`), conteudo);
      console.log("Relatório salvo no Firestore:", conteudo);

      alert("Relatório enviado com sucesso!");
      setRelatorioFile(null); // Limpar o estado do arquivo selecionado
      setModalRelatorioOpen(false); // Fechar o modal
    } catch (error) {
      console.error("Erro ao enviar relatório:", error.message || error);
      alert("Erro ao enviar relatório. Tente novamente.");
    }
  };

  const handleReuniaoSubmit = async () => {
    // Validações para cliente, data e hora
    if (!selectedCliente) {
      alert("Selecione um cliente válido antes de agendar a reunião.");
      return;
    }

    if (!reuniaoData || !reuniaoHora) {
      alert("Preencha a data e a hora da reunião.");
      return;
    }

    try {
      // Monta o conteúdo da reunião
      const conteudo = `Reunião agendada para ${new Date(reuniaoData).toLocaleDateString("pt-BR")} às ${reuniaoHora}`;

      // Adiciona a reunião no Firestore
      await addDoc(collection(firestore, `usuarios/${selectedCliente.id}/consultor`), {
        consultorId: auth.currentUser?.uid, // ID do consultor
        tipo: "reuniao",
        conteudo,
        data: new Date().toISOString(),
      });

      // Mensagem de sucesso e fechamento do modal
      alert("Reunião agendada com sucesso!");
      setReuniaoData(""); // Reseta a data
      setReuniaoHora(""); // Reseta a hora
      setModalReuniaoOpen(false); // Fecha o modal
    } catch (error) {
      console.error("Erro ao agendar reunião:", error.message || error);
      alert("Erro ao agendar reunião. Tente novamente.");
    }
  };

  const handleRecomendacaoSubmit = async () => {
    if (!selectedCliente) {
      console.error("Nenhum cliente selecionado:", selectedCliente);
      alert("Selecione um cliente para enviar uma recomendação.");
      return;
    }

    if (!recomendacaoTexto.trim()) {
      console.error("Texto de recomendação vazio:", recomendacaoTexto);
      alert("Digite uma recomendação antes de enviar.");
      return;
    }

    try {
      console.log("Cliente selecionado:", selectedCliente);
      console.log("Texto da recomendação:", recomendacaoTexto);

      await saveConsultoriaData("recomendacao", recomendacaoTexto);

      alert("Recomendação enviada com sucesso!");
      setRecomendacaoTexto(""); // Limpa o campo de texto após o envio
      setModalRecomendacaoOpen(false);
    } catch (error) {
      console.error("Erro ao enviar recomendação:", error.message || error);
      alert("Erro ao enviar recomendação. Tente novamente.");
    }
  };

  const [filter, setFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]); // Inicializa como uma lista vazia
  const [filterCategory, setFilterCategory] = useState("");

  const handleSearch = (autoLoad = false) => {
    let filtered = userDetails.lancamentos;

    if (!autoLoad) {
      if (!startDate || !endDate) {
        alert("Por favor, selecione um intervalo de datas.");
        return;
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        alert("A data inicial não pode ser maior que a data final.");
        return;
      }

      filtered = filtered.filter((lancamento) => {
        if (!lancamento.data) return false;

        // Converte a data do lançamento para comparação
        const [dia, mes, ano] = lancamento.data.split("/");
        const lancamentoDate = new Date(`${ano}-${mes}-${dia}T00:00:00`);

        return lancamentoDate >= start && lancamentoDate <= end;
      });
    }

    // Filtra apenas lançamentos pagos
    const pagos = filtered.filter((lancamento) => lancamento.pago);
    setFilteredData(pagos);

    if (!autoLoad && pagos.length === 0) {
      alert("Nenhum lançamento encontrado no período especificado.");
    }
  };

  // Função robusta e definitiva para converter qualquer valor (string ou número)
  const parseValor = (valor) => {
    if (typeof valor === "number") return valor;
    if (typeof valor === "string") {
      return parseFloat(valor.replace("R$", "").replace(/\./g, "").replace(",", ".").trim()) || 0;
    }
    return 0;
  };

  // ✅ Função para calcular o saldo
  const calculateTotais = () => {
    const dataToCalculate = filteredData.length > 0 ? filteredData : userDetails.lancamentos;

    const totalReceitas = dataToCalculate
      .filter((item) => item.tipo === "Receita")
      .reduce((acc, item) => acc + parseValor(item.valor), 0);

    const totalDespesasFixas = dataToCalculate
      .filter((item) => item.tipo === "Despesa Fixa")
      .reduce((acc, item) => acc + parseValor(item.valor), 0);

    const totalDespesasVariaveis = dataToCalculate
      .filter((item) => item.tipo === "Despesa Variável")
      .reduce((acc, item) => acc + parseValor(item.valor), 0);

    const saldoFinal = totalReceitas - (totalDespesasFixas + totalDespesasVariaveis);

    setReceitas(totalReceitas);
    setDespesasFixas(totalDespesasFixas);
    setDespesasVariaveis(totalDespesasVariaveis);
    setSaldo(saldoFinal);
  };

  // ✅ Atualização automática quando muda os lançamentos
  useEffect(() => {
    if (userDetails.lancamentos.length > 0) {
      calculateTotais();
    }
  }, [userDetails.lancamentos, filteredData]);

  const resetFilters = () => {
    setStartDate(""); // Zera a data inicial
    setEndDate(""); // Zera a data final
    setFilterCategory(""); // Zera a categoria de filtro
    setFilteredData([]); // Zera os dados filtrados
  };
  const [modalLancamentosOpen, setModalLancamentosOpen] = useState(false);
  const [modalMetasOpen, setModalMetasOpen] = useState(false);
  const [modalInvestimentosOpen, setModalInvestimentosOpen] = useState(false);

  useEffect(() => {
    if (modalLancamentosOpen) {
      handleSearch(true); // Carregar lançamentos pagos automaticamente ao abrir
    }
  }, [modalLancamentosOpen]);

  const handleMetaSearch = (autoLoad = false) => {
    let filtered = userDetails.metas;

    if (!autoLoad) {
      if (!startDate || !endDate) {
        setFilteredData(userDetails.metas); // Se não filtrar, exibe todas as metas
        return;
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      if (start > end) {
        alert("A data inicial não pode ser maior que a data final.");
        return;
      }

      filtered = filtered.filter((meta) => {
        if (!meta.prazo) return false;

        let prazoDate = meta.prazo;
        if (prazoDate?.toDate) {
          prazoDate = prazoDate.toDate();
        } else {
          prazoDate = new Date(prazoDate);
        }

        return prazoDate.getTime() >= start.getTime() && prazoDate.getTime() <= end.getTime();
      });
    }

    setFilteredData(filtered);
  };

  useEffect(() => {
    if (modalMetasOpen) {
      handleMetaSearch(true); // Carregar todas as metas ao abrir
    }
  }, [modalMetasOpen]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDTypography variant="h5" mb={3}>
          Painel do Consultor
        </MDTypography>
        <Grid container spacing={2}>
          {clientes.map((cliente) => (
            <Grid item xs={12} md={6} key={cliente.id}>
              <Card>
                <MDBox
                  p={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  flexWrap="wrap" // Permite quebra de linha em telas menores
                  style={{ gap: "16px" }} // Espaçamento consistente entre os itens
                >
                  <MDTypography
                    variant="subtitle1"
                    style={{
                      wordWrap: "break-word", // Quebra palavras muito longas
                      overflowWrap: "break-word", // Quebra corretamente para e-mails e textos longos
                      maxWidth: "100%", // Limita o tamanho ao card
                    }}
                  >
                    <strong>Nome:</strong> {cliente.name} <br />
                    <strong>Email:</strong> {cliente.email}
                  </MDTypography>
                  <MDBox
                    display="flex"
                    gap={2}
                    flexWrap="wrap" // Permite que os ícones fiquem em várias linhas, se necessário
                    justifyContent="flex-start" // Alinha à esquerda em telas menores
                  >
                    <IconButton
                      onClick={() => {
                        if (!cliente) {
                          alert("Selecione um cliente válido.");
                          return;
                        }
                        setSelectedCliente(cliente);
                        setModalRelatorioOpen(true); // Abre o modal
                      }}
                    >
                      <DescriptionIcon style={{ color: "#2979ff" }} />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        if (!cliente) {
                          alert("Selecione um cliente válido.");
                          return;
                        }
                        setSelectedCliente(cliente); // Define o cliente selecionado
                        setModalReuniaoOpen(true); // Abre o modal de reunião
                      }}
                    >
                      <EventIcon style={{ color: "#4caf50" }} />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        setSelectedCliente(cliente); // Define o cliente selecionado
                        setModalRecomendacaoOpen(true); // Abre o modal
                      }}
                    >
                      <ChatBubbleOutlineIcon style={{ color: "#ff9800" }} />
                    </IconButton>

                    <IconButton onClick={() => handleViewUser(cliente)}>
                      <VisibilityIcon style={{ color: "#673ab7" }} />
                    </IconButton>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      {/* Modal Visualizar */}
      <Dialog
        open={modalVisualizarOpen}
        onClose={() => setModalVisualizarOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: darkMode ? "#1E1E1E" : theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }),
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: darkMode ? "#2E3B4E" : "#F0F4F8",
            color: darkMode ? "#E1E6EB" : "#33475B",
            textAlign: "center",
            padding: "20px",
            fontWeight: "bold",
            borderBottom: darkMode ? "1px solid #3B495F" : "1px solid #DDE3E9",
          }}
        >
          {selectedCliente?.name ? selectedCliente.name : "Visualizar Usuário"}
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: darkMode ? "#333C48" : "#FFFFFF",
            color: darkMode ? "#E1E6EB" : "#000000",
            padding: "24px",
            borderRadius: "8px",
          }}
        >
          <MDBox display="flex" justifyContent="center" gap={2} mb={3}>
            <MDButton color="info" variant="contained" onClick={() => setModalLancamentosOpen(true)}>
              Lançamentos
            </MDButton>
            <MDButton color="warning" variant="contained" onClick={() => setModalMetasOpen(true)}>
              Metas
            </MDButton>
            <MDButton color="success" variant="contained" onClick={() => setModalInvestimentosOpen(true)}>
              Investimentos
            </MDButton>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setModalVisualizarOpen(false)} color="error">
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal Lançamentos */}
      <Dialog
        open={modalLancamentosOpen}
        onClose={() => {
          resetFilters();
          setModalLancamentosOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Lançamentos</DialogTitle>
        <DialogContent>
          {/* Filtros */}
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <TextField
              label="Data Início"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label="Data Final"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <MDButton onClick={() => handleSearch(false)} color="info">
              Buscar
            </MDButton>
          </MDBox>

          {/* Accordion Receitas */}
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography color="green" fontWeight="bold">
                Receitas - Total: {`R$ ${receitas.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {filteredData
                .filter((lanc) => lanc.tipo === "Receita" && lanc.pago)
                .map((lanc) => (
                  <MDBox key={lanc.id} display="flex" justifyContent="space-between" px={2}>
                    <MDTypography>{lanc.categoria || "Não informado"}</MDTypography>
                    <MDTypography>{lanc.valor || "R$ 0,00"}</MDTypography>
                  </MDBox>
                ))}
            </AccordionDetails>
          </Accordion>

          {/* Accordion Despesas Fixas */}
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography color="error" fontWeight="bold">
                Despesas Fixas - Total: {`R$ ${despesasFixas.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {filteredData
                .filter((lanc) => lanc.tipo === "Despesa Fixa" && lanc.pago)
                .map((lanc) => (
                  <MDBox key={lanc.id} display="flex" justifyContent="space-between" px={2}>
                    <MDTypography>{lanc.categoria || "Não informado"}</MDTypography>
                    <MDTypography>{lanc.valor || "R$ 0,00"}</MDTypography>
                  </MDBox>
                ))}
            </AccordionDetails>
          </Accordion>

          {/* Accordion Despesas Variáveis */}
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography color="warning.main" fontWeight="bold">
                Despesas Variáveis - Total:{" "}
                {`R$ ${despesasVariaveis.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {filteredData
                .filter((lanc) => lanc.tipo === "Despesa Variável" && lanc.pago)
                .map((lanc) => (
                  <MDBox key={lanc.id} display="flex" justifyContent="space-between" px={2}>
                    <MDTypography>{lanc.categoria || "Não informado"}</MDTypography>
                    <MDTypography>{lanc.valor || "R$ 0,00"}</MDTypography>
                  </MDBox>
                ))}
            </AccordionDetails>
          </Accordion>

          {/* Saldo Final */}
          <MDBox mt={2} textAlign="center">
            <MDTypography variant="h6">
              Saldo Final:{" "}
              <span style={{ color: saldo >= 0 ? "green" : "red" }}>
                {`R$ ${saldo.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`}
              </span>
            </MDTypography>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton
            onClick={() => {
              resetFilters();
              setModalLancamentosOpen(false);
            }}
            color="error"
          >
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
      {/* Modal Metas */}
      <Dialog open={modalMetasOpen} onClose={() => setModalMetasOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Metas</DialogTitle>
        <DialogContent>
          {/* Filtros de data */}
          <MDBox display="flex" flexWrap="wrap" gap={2} alignItems="center" justifyContent="flex-start" mb={2}>
            <MDBox display="flex" flexDirection="column">
              <MDTypography variant="caption" fontWeight="medium" mb={0.5}>
                Data Início
              </MDTypography>
              <TextField
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                size="small"
                sx={{ width: 180 }}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>

            <MDBox display="flex" flexDirection="column">
              <MDTypography variant="caption" fontWeight="medium" mb={0.5}>
                Data Final
              </MDTypography>
              <TextField
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                size="small"
                sx={{ width: 180 }}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>

            <MDButton onClick={handleMetaSearch} color="info" variant="contained" sx={{ height: "40px", px: 3 }}>
              Buscar
            </MDButton>
          </MDBox>

          {/* Tabela de Metas */}
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Meta</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Valor</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Prazo</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Dias Restantes</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Aportado</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData.map((meta) => (
                    <TableRow key={meta.id}>
                      <TableCell>{meta.nome || "Sem nome"}</TableCell>
                      <TableCell>
                        R$ {meta.valor?.toLocaleString("pt-BR", { minimumFractionDigits: 2 }) || "0,00"}
                      </TableCell>
                      <TableCell>
                        {meta.prazo ? new Date(meta.prazo).toLocaleDateString("pt-BR") : "Não informado"}
                      </TableCell>
                      <TableCell>
                        {meta.prazo
                          ? Math.max(
                              Math.ceil(
                                (new Date(meta.prazo).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
                              ),
                              0
                            ) + " dias"
                          : "Não informado"}
                      </TableCell>
                      <TableCell>
                        R${" "}
                        {meta.aportesRegistrados
                          ? meta.aportesRegistrados
                              .reduce((total, aporte) => total + aporte, 0)
                              .toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                              })
                          : "0,00"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      Nenhuma meta encontrada.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setModalMetasOpen(false)} color="error">
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
      {/* Modal Investimentos */}
      <Dialog open={modalInvestimentosOpen} onClose={() => setModalInvestimentosOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Investimentos</DialogTitle>
        <DialogContent>
          {/* Filtros de data */}
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <TextField
              label="Data Início"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true, style: { fontSize: "14px", marginTop: "6px" } }} // Ajustado para evitar corte
            />
            <TextField
              label="Data Final"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true, style: { fontSize: "14px", marginTop: "6px" } }} // Ajustado para evitar corte
            />
            <MDButton onClick={() => handleSearch(false)} color="info">
              Buscar
            </MDButton>
          </MDBox>

          {/* Resultados */}
          {filteredData.length > 0 ? (
            filteredData.map((inv) => (
              <MDBox key={inv.id} display="flex" justifyContent="space-between">
                <MDTypography>{inv.ativo}</MDTypography>
                <MDTypography>{inv.valorAplicado}</MDTypography>
              </MDBox>
            ))
          ) : (
            <MDTypography>Nenhum investimento encontrado.</MDTypography>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setModalInvestimentosOpen(false)} color="error">
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>
      {/* Modal Relatório */}
      <Dialog
        open={modalRelatorioOpen}
        onClose={() => setModalRelatorioOpen(false)}
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : theme.palette.background.default, // Fundo dinâmico
            color: theme.palette.text.primary, // Texto dinâmico
            borderRadius: "12px", // Bordas arredondadas
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Sombra para destaque
          }),
        }}
      >
        <DialogTitle>Enviar Relatório</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => setRelatorioFile(e.target.files[0])}
              style={{ marginTop: "16px" }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setModalRelatorioOpen(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={handleRelatorioSubmit} color="info">
            Enviar
          </MDButton>
        </DialogActions>
      </Dialog>
      {/* Modal Reunião */}
      <Dialog
        open={modalReuniaoOpen}
        onClose={() => setModalReuniaoOpen(false)}
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : theme.palette.background.default, // Fundo dinâmico
            color: theme.palette.text.primary, // Texto dinâmico
            borderRadius: "12px", // Bordas arredondadas
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Sombra para destaque
          }),
        }}
      >
        <DialogTitle>Agendar Reunião</DialogTitle>
        <DialogContent>
          <TextField
            label="Data"
            type="date"
            fullWidth
            value={reuniaoData}
            onChange={(e) => setReuniaoData(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginTop: "16px", marginBottom: "8px" }}
          />
          <TextField
            label="Hora"
            type="time"
            fullWidth
            value={reuniaoHora}
            onChange={(e) => setReuniaoHora(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginTop: "8px", marginBottom: "16px" }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setModalReuniaoOpen(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={handleReuniaoSubmit} color="info">
            Agendar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Modal Recomendação */}
      <Dialog
        open={modalRecomendacaoOpen}
        onClose={() => setModalRecomendacaoOpen(false)}
        PaperProps={{
          sx: (theme) => ({
            backgroundColor: theme.palette.mode === "dark" ? "#1E1E1E" : theme.palette.background.default, // Fundo dinâmico
            color: theme.palette.text.primary, // Texto dinâmico
            borderRadius: "12px", // Bordas arredondadas
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Sombra para destaque
          }),
        }}
      >
        <DialogTitle>
          <MDTypography variant="h5">Enviar Recomendação</MDTypography>
          <MDTypography variant="subtitle2" color="textSecondary">
            Detalhe as ações recomendadas para o cliente
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              padding: 2,
              border: "1px solid #ccc",
              borderRadius: "12px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              backgroundColor: darkMode ? "#2E2E2E" : "#FFF",
            }}
          >
            <TextField
              multiline
              rows={6}
              fullWidth
              placeholder="Ex.: Ajustar os limites de gastos nas categorias de despesas variáveis..."
              value={recomendacaoTexto}
              onChange={(e) => setRecomendacaoTexto(e.target.value)}
              label="Escreva sua recomendação"
              InputLabelProps={{
                style: { fontWeight: "bold", fontSize: "1rem" },
              }}
              sx={{
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => setModalRecomendacaoOpen(false)}
            color="secondary"
            sx={{ backgroundColor: "#F44336", color: "#FFF" }}
          >
            Cancelar
          </MDButton>
          <MDButton onClick={handleRecomendacaoSubmit} color="info" sx={{ backgroundColor: "#2979FF", color: "#FFF" }}>
            Enviar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default PainelConsultor;
